import { render, staticRenderFns } from "./comparing-journal.vue?vue&type=template&id=595f27c7&scoped=true"
import script from "./comparing-journal.vue?vue&type=script&lang=js"
export * from "./comparing-journal.vue?vue&type=script&lang=js"
import style0 from "./comparing-journal.vue?vue&type=style&index=0&id=595f27c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595f27c7",
  null
  
)

export default component.exports